import React from 'react';
import * as Ons from 'react-onsenui';
import Checklist from '../GameReportReferee/Checklist';
import Scores from '../GameReportReferee/Scores';
import Toolbar from '../Toolbar';
import PullHook from '../PullHook';
import AutoComplete from '../Controls/AutoComplete';
import HoldButton from '../Controls/HoldButton';
import AutoTextarea from '../Controls/AutoTextarea';
import ColorSelect from '../Controls/ColorSelect';
import { translate as _ } from '../../util/i18n';
import { expired, getActionButtonPosition } from '../../util';
import { showAlert } from '../../util/ui';
import { getGameReportRefereeConfig, getGameReportRefereeExpirationTimeForTeamSignature, getUrl } from '../../util/context';
import { GRR_DRAFT, GRR_SIGNED_BY_REF, GRR_COMPLETED } from '../../store/constants/statusCodes';

class GameReportReferee extends React.Component {

    #actionButtonClass;
    #gameReportRefereeConfig;
    #pullHookCallback;
    #team;

    constructor( props ) {

        // console.log( 'components.Pages.GameReportReferee.constructor()', props );

        super( props );

        this.state = {
            pullHook: 'initial'
        };

        this.getTeamSignatureExpirationDate = this.getTeamSignatureExpirationDate.bind( this );
        this.getStatusText                  = this.getStatusText.bind( this );
        this.handleBackClick                = this.handleBackClick.bind( this );
        this.handleChange                   = this.handleChange.bind( this );
        this.handleDismissChangesClick      = this.handleDismissChangesClick.bind( this );
        this.handleInputChange              = this.handleInputChange.bind( this );
        this.handleLoadScoresClick          = this.handleLoadScoresClick.bind( this );
        this.handleOverwriteClick           = this.handleOverwriteClick.bind( this );
        this.handlePullHookChange           = this.handlePullHookChange.bind( this );
        this.handlePullHookLoad             = this.handlePullHookLoad.bind( this );
        this.handleSaveDraftClick           = this.handleSaveDraftClick.bind( this );
        this.handleSignClick                = this.handleSignClick.bind( this );
        this.reloadData                     = this.reloadData.bind( this );
        this.requiredFieldsFilledIn         = this.requiredFieldsFilledIn.bind( this );
        this.teamSignatureExpired           = this.teamSignatureExpired.bind( this );

        this.#gameReportRefereeConfig = getGameReportRefereeConfig( this.props.context );

        if ( this.props.activeGame ) {

            if ( this.props.activeGame.permission === 'home' ) {

                this.#team = 'home';

            } else if ( this.props.activeGame.permission === 'away' ) {

                this.#team = 'away';

            }

        }

        this.#actionButtonClass = 'bottom ' + [ 'left', 'center', 'right' ][ getActionButtonPosition( this.props.userSettings ) ];

    }

    componentDidMount() {

        ( expired( this.props.gameReportRefereeLastUpdate ) || ( this.props.activeGame.permission === 'referee' && expired( this.props.refereesLastUpdate ) ) ) && this.reloadData();

    }

    componentDidUpdate() {

        if ( this.#pullHookCallback ) {

            const cb = this.#pullHookCallback;

            setTimeout( () => cb(), 1000 );

            this.#pullHookCallback = null;

        }

    }

    canOverwrite() {

        return this.props.gameReportRefereeMeta.status === GRR_COMPLETED && this.props.gameReportRefereeMeta.editLevel === 1;

    }

    getTeamSignatureExpirationDate() {

        if ( ! this.props.gameReportRefereeMeta.statusChangedAt ) {

            return null;

        }

        return new Date( ( new Date( this.props.gameReportRefereeMeta.statusChangedAt ) ).getTime() + getGameReportRefereeExpirationTimeForTeamSignature( this.props.context ) );

    }

    getStatusText() {

        switch ( this.props.gameReportRefereeMeta.status ) {

            case GRR_DRAFT:         return _( 'Entwurf'        );
            case GRR_SIGNED_BY_REF: return _( 'Unterschrieben' );
            case GRR_COMPLETED:     return _( 'Abgeschlossen'  );

            default: return '';

        }

    }

    handleBackClick() {

        this.props.onChangePage( { page: 'game' } );

    }

    handleChange( key, value ) {

        this.props.onUpdateGameReportReferee( this.props.activeGame.id, { [ key ]: value } );

    }

    handleDismissChangesClick() {

        showAlert( {

            buttonLabels: [ _( 'Abbrechen' ), _( 'OK' ) ],
            callback:     e => e === 1 && this.props.onDismissChanges( this.props.activeGame.id ),
            cancelable:   true,
            message:      _( 'Änderungen verwerfen?' ),
            title:        ''

        } );

    }

    handleInputChange( e ) {

        let name  = e.target.name.split( '.' );
        let value = e.target.value;

        if ( name.length === 2 ) {

            value = { ...this.props.gameReportReferee[ name[ 0 ] ], [ name[ 1 ] ]: value };

        }

        this.handleChange( name[ 0 ], value );

    }

    handleLoadScoresClick() {

        this.props.onLoadScores( this.props.context, this.props.activeGame.id );

    }

    handleOverwriteClick() {

        this.props.onOverwrite( this.props.context, this.props.token, this.props.activeGame.id, this.props.gameReportReferee );

        return false;

    }

    handlePullHookChange( e ) {

        this.setState( { pullHook: e.state } );

    }

    handlePullHookLoad( e ) {

        this.#pullHookCallback = e;

        this.reloadData();

    }

    handleSaveDraftClick() {

        this.props.onSaveDraft( this.props.context, this.props.token, this.props.activeGame.id, this.props.gameReportReferee );

        return false;

    }

    handleSignClick() {

        if ( this.props.activeGame.permission === 'referee' ) {

            this.props.onConfirm( this.props.context, this.props.token, this.props.activeGame.id, this.props.gameReportReferee, this.props.username );

        } else {

            const key     = 'notes' + ( this.#team === 'home' ? 'Home' : 'Away' );
            const comment = this.props.gameReportReferee[ key ].comment;
            const name    = this.props.gameReportReferee[ key ].name;

            this.props.onSign( this.props.context, this.props.token, this.props.activeGame.id, this.#team, comment, name, this.props.username );

        }

    }

    reloadData() {

        this.props.onLoadGameReportReferee( this.props.context, this.props.token, this.props.activeGame.id );

        this.props.activeGame.permission === 'referee' && this.props.onLoadReferees( this.props.context, this.props.token, this.props.activeGame.id );

    }

    renderInput( e ) {

        const name  = ( 'key2' in e ) ? e.key + '.' + e.key2 : e.key;
          let value = ( 'key2' in e ) ? this.props.gameReportReferee[ e.key ][ e.key2 ] : this.props.gameReportReferee[ e.key ];

        if ( ! ( 'readonly' in e ) ) {

            e.readonly = ( this.props.activeGame.permission !== 'referee' || this.props.gameReportRefereeMeta.status !== GRR_DRAFT ) && ! this.canOverwrite();

        }

        if ( value === undefined || value === null || value === 'null' ) {

            value = '';

        }

        const props = {

            id:       'grr-' + e.key,
            modifier: 'underbar',
            onChange: this.handleInputChange,
            type:     e.type || 'text',

            name, value

        };

        if ( e.readonly ) {

            if ( props.type === 'color' ) {

                props.disabled = true;

            } else {

                props.readonly = true;

            }

        }

        return (

            <div className="form-control" key={( 'key2' in e ) ? e.key + e.key2 : e.key}>

                <label htmlFor={'grr-' + e.key}>{_( e.title )}:</label>

                {props.type === 'color' ? <ColorSelect {...props} /> : <Ons.Input {...props} />}

            </div>

        );

    }

    renderGameInfo() {

        return this.#gameReportRefereeConfig.gameInfo.map( e => this.renderInput( { ...e } ) );

    }

    renderOfficials() {

        return this.#gameReportRefereeConfig.officials.map( e => (

            <div className="form-control" key={e.key}>

                <label htmlFor={'grr-' + e.key}>{_( e.title )}:</label>

                <AutoComplete
                    className="text-input text-input--underbar"
                    id={'gameOfficials.' + e.key}
                    name={'gameOfficials.' + e.key}
                    onChange={this.handleInputChange}
                    readonly={( this.props.activeGame.permission !== 'referee' || this.props.gameReportRefereeMeta.status !== GRR_DRAFT ) && ! this.canOverwrite()}
                    suggestions={this.props.referees}
                    value={this.props.gameReportReferee.gameOfficials[ e.key ]}
                />

            </div>

        ) );

    }

    renderTeamInfo( team ) {

        return this.#gameReportRefereeConfig.teamInfo.map( e => this.renderInput( { key: 'teamInfo' + team, ...e } ) );

    }

    requiredFieldsFilledIn() {

        return (

            this.props.gameReportReferee.gameName &&
            this.props.gameReportReferee.town &&
            this.props.gameReportReferee.location &&
            this.props.gameReportReferee.gameDate &&
            this.props.gameReportReferee.gameStart &&
            this.props.gameReportReferee.gameEnd &&
            // this.props.gameReportReferee.gameOfficials.referee &&
            // this.props.gameReportReferee.gameOfficials.centerjudge &&
            // this.props.gameReportReferee.gameOfficials.umpire &&
            // this.props.gameReportReferee.gameOfficials.linesman &&
            // this.props.gameReportReferee.gameOfficials.linejudge &&
            // this.props.gameReportReferee.gameOfficials.backjudge &&
            // this.props.gameReportReferee.gameOfficials.fieldjudge &&
            // this.props.gameReportReferee.gameOfficials.sidejudge &&
            // this.props.gameReportReferee.gameOfficials.timekeeper &&
            // this.props.gameReportReferee.gameOfficials.shotclock &&
            // this.props.gameReportReferee.gameOfficials.observer &&
            this.props.gameReportReferee.teamInfoHome.teamName &&
            // this.props.gameReportReferee.teamInfoHome.representative &&
            // this.props.gameReportReferee.teamInfoHome.gameManager &&
            // this.props.gameReportReferee.teamInfoHome.colorHelmets &&
            // this.props.gameReportReferee.teamInfoHome.colorShirts &&
            // this.props.gameReportReferee.teamInfoHome.colorPants &&
            // this.props.gameReportReferee.teamInfoHome.colorSocks &&
            // this.props.gameReportReferee.teamInfoHome.disqualifications &&
            this.props.gameReportReferee.teamInfoAway.teamName &&
            // this.props.gameReportReferee.teamInfoAway.representative &&
            // this.props.gameReportReferee.teamInfoAway.gameManager &&
            // this.props.gameReportReferee.teamInfoAway.colorHelmets &&
            // this.props.gameReportReferee.teamInfoAway.colorShirts &&
            // this.props.gameReportReferee.teamInfoAway.colorPants &&
            // this.props.gameReportReferee.teamInfoAway.colorSocks &&
            // this.props.gameReportReferee.teamInfoAway.disqualifications &&
            this.props.gameReportReferee.equipmentHome.isOk !== null &&
            this.props.gameReportReferee.equipmentAway.isOk !== null &&
            this.props.gameReportReferee.fieldEquipment.isOk !== null &&
            this.props.gameReportReferee.eventStaff.isOk !== null &&
            this.props.gameReportReferee.notesOfficials.name

        );

    }

    renderTeamNotes( team ) {

        const key      = 'notes' + ( team === 'home' ? 'Home' : 'Away' );
        const readonly = this.props.activeGame.permission === 'referee' || this.props.gameReportRefereeMeta.status !== GRR_SIGNED_BY_REF || team !== this.#team || this.props.gameReportRefereeMeta[ team + 'ConfirmationAt' ];

        return (

            <Ons.Card className={this.#team === team && ! readonly && ! this.teamSignatureExpired() ? 'primary' : ''}>

                <h3>{_( 'Anmerkungen' )} ({_( team === 'home' ? 'Heim' : 'Gast' )})</h3>

                <fieldset disabled={this.props.loading} >

                    <div className="form-control break">

                        <label htmlFor={'grr-notes-officials-' + team}>{_( 'Kommentar' )}:</label>

                        <AutoTextarea
                            id={'grr-notes-officials-' + team}
                            name={key + '.comment'}
                            onChange={this.handleInputChange}
                            readonly={readonly}
                            value={this.props.gameReportReferee[ key ].comment}
                        />

                    </div>

                    {this.renderInput( { title: 'Name', key, key2: 'name', readonly } )}

                </fieldset>

            </Ons.Card>

        );

    }

    teamSignatureExpired() {

        return this.getTeamSignatureExpirationDate() < new Date();

    }

    render() {

        // console.log( 'components.Pages.GameReportReferee.render()', this.props, this.state );

        if ( ! this.props.activeGame ) {

            this.props.onChangePage( { page: 'games' } );

            return '';

        }

        const canOverwrite         = this.canOverwrite();
        const readonly             = ( this.props.activeGame.permission !== 'referee' || this.props.gameReportRefereeMeta.status !== GRR_DRAFT ) && ! canOverwrite;
        const canBeSignedByReferee = this.props.activeGame.permission === 'referee' && this.props.gameReportRefereeMeta.status === GRR_DRAFT;
        const canBeSignedByTeam    = this.props.activeGame.permission !== 'referee' && this.props.gameReportRefereeMeta.status === GRR_SIGNED_BY_REF && this.props.gameReportRefereeMeta[ this.#team + 'ConfirmationAt' ] === null;

        const notesOfficialsMercyRulePeriodProps = {

            id:       'grr-notes-officials-mercy-rule-period',
            name:     'notesOfficials.mercyRulePeriod',
            modifier: 'underbar',
            onChange: this.handleInputChange,
            type:     'text',
            value:    this.props.gameReportReferee.notesOfficials.mercyRulePeriod

        };

        const notesOfficialsMercyRuleTimeProps = {

            id:       'grr-notes-officials-mercy-rule-time',
            name:     'notesOfficials.mercyRuleTime',
            modifier: 'underbar',
            onChange: this.handleInputChange,
            type:     'text',
            value:    this.props.gameReportReferee.notesOfficials.mercyRuleTime

        };

        if ( readonly ) {

            notesOfficialsMercyRulePeriodProps.readonly = true;
            notesOfficialsMercyRuleTimeProps.readonly   = true;

        } else {

            notesOfficialsMercyRulePeriodProps.placeholder = _( 'Period'    );
            notesOfficialsMercyRuleTimeProps.placeholder   = _( 'Spielzeit' );

        }

        return (

            <Ons.Page renderToolbar={() => <Toolbar title={_( 'Game Report Referee' )} onBackClick={this.handleBackClick} onMenuClick={this.props.onMenuClick} onReloadClick={this.reloadData} />}>

                <PullHook onChange={this.handlePullHookChange} onLoad={this.handlePullHookLoad} />

                {this.props.loading && this.state.pullHook !== 'action' && <Ons.ProgressBar indeterminate className="fixed-progress-bar" />}

                <h1 className="page-title">{_( 'Game Report Referee' )}</h1>

                <form autoComplete="off" onSubmit={this.handleSaveDraftClick} className="form form-horizontal game-report-referee">

                    <Ons.Card class="primary">

                        <dl>

                            <dt>{_( 'Status' )}</dt>
                            <dd>{this.getStatusText()}</dd>

                            <dt>{_( 'Datum' )}</dt>
                            <dd>{this.props.gameReportRefereeMeta.statusChangedAt ? ( new Date( this.props.gameReportRefereeMeta.statusChangedAt ) ).toLocaleString() : '-'}</dd>

                            <dt>{_( 'Von' )}</dt>
                            <dd>{this.props.gameReportRefereeMeta.statusChangedBy || '-'}</dd>

                            <div className="divider"></div>

                            <dt>{_( 'Heimteam' )}</dt>
                            <dd></dd>

                            <dt>{_( 'Unterschrieben' )}</dt>
                            <dd>{this.props.gameReportRefereeMeta.homeConfirmationAt ? ( new Date( this.props.gameReportRefereeMeta.homeConfirmationAt ) ).toLocaleString() : '-'}</dd>

                            <dt>{_( 'Von' )}</dt>
                            <dd>{this.props.gameReportRefereeMeta.homeConfirmationBy || '-'}</dd>

                            <div className="divider"></div>

                            <dt>{_( 'Gastteam' )}</dt>
                            <dd></dd>

                            <dt>{_( 'Unterschrieben' )}</dt>
                            <dd>{this.props.gameReportRefereeMeta.awayConfirmationAt ? ( new Date( this.props.gameReportRefereeMeta.awayConfirmationAt ) ).toLocaleString() : '-'}</dd>

                            <dt>{_( 'Von' )}</dt>
                            <dd>{this.props.gameReportRefereeMeta.awayConfirmationBy || '-'}</dd>

                        </dl>

                    </Ons.Card>

                    {this.props.gameReportRefereeMeta.status === GRR_COMPLETED &&

                        <div className="padded-page-content">

                            <Ons.Row>

                                <Ons.Col width="50"><a href={getUrl( this.props.context, 'GameReportRefereeDocument' ) + '?gameId=' + this.props.activeGame.id + '&token=' + this.props.token} target="_blank" rel="noreferrer" className="button button--large button--outline">{_( 'Druckansicht' )}</a></Ons.Col>
                                <Ons.Col width="50"><a href={getUrl( this.props.context, 'GameReportRefereePDF'      ) + '?gameId=' + this.props.activeGame.id + '&token=' + this.props.token} target="_blank" rel="noreferrer" className="button button--large button--outline">{_( 'PDF-Ansicht'  )}</a></Ons.Col>

                            </Ons.Row>

                        </div>

                    }

                    <Ons.Card>

                        <h3>{_( 'Spiel' )}</h3>

                        <fieldset disabled={this.props.loading}>

                            {this.renderGameInfo()}

                        </fieldset>

                    </Ons.Card>

                    <Ons.Card>

                        <h3>{_( 'Offizielle' )}</h3>

                        <fieldset disabled={this.props.loading}>

                            {this.renderOfficials()}

                        </fieldset>

                    </Ons.Card>

                    <Ons.Card>

                        <h3>{_( 'Heimteam' )}</h3>

                        <fieldset disabled={this.props.loading}>

                            {this.renderTeamInfo( 'Home' )}

                        </fieldset>

                    </Ons.Card>

                    <Ons.Card>

                        <h3>{_( 'Gastteam' )}</h3>

                        <fieldset disabled={this.props.loading}>

                            {this.renderTeamInfo( 'Away' )}

                        </fieldset>

                    </Ons.Card>

                    <Ons.Card>

                        <h3>

                            {! readonly && <div className="pull-right"><Ons.Button disabled={this.props.loading} onClick={this.handleLoadScoresClick} modifier="quiet">{_( 'Autofill' )}</Ons.Button></div>}

                            {_( 'Scores' )}

                        </h3>

                        <fieldset>

                            <Scores
                                config={this.#gameReportRefereeConfig.scores}
                                disabled={this.props.loading}
                                gameReportReferee={this.props.gameReportReferee}
                                onChange={this.handleChange}
                                readonly={readonly}
                            />

                        </fieldset>

                    </Ons.Card>

                    <Ons.Card>

                        <h3>{_( 'Spieler-Equipment' )} {_( 'Heim' )}</h3>

                        <fieldset>

                            <Checklist
                                config={this.#gameReportRefereeConfig.playerEquipment}
                                disabled={this.props.loading || ( readonly && ! this.canOverwrite() )}
                                id="equipmentHome"
                                inputPlaceholder={_( 'Trikotnummern' )}
                                onChange={e => this.handleChange( 'equipmentHome', e )}
                                values={this.props.gameReportReferee.equipmentHome}
                            />

                        </fieldset>

                    </Ons.Card>

                    <Ons.Card>

                        <h3>{_( 'Spieler-Equipment' )} {_( 'Gast' )}</h3>

                        <fieldset>

                            <Checklist
                                config={this.#gameReportRefereeConfig.playerEquipment}
                                disabled={this.props.loading || readonly}
                                id="equipmentAway"
                                inputPlaceholder={_( 'Trikotnummern' )}
                                onChange={e => this.handleChange( 'equipmentAway', e )}
                                values={this.props.gameReportReferee.equipmentAway}
                            />

                        </fieldset>

                    </Ons.Card>

                    <Ons.Card>

                        <h3>{_( 'Field-Equipment' )}</h3>

                        <fieldset>

                            <Checklist
                                config={this.#gameReportRefereeConfig.fieldEquipment}
                                disabled={this.props.loading || readonly}
                                id="fieldEquipment"
                                inputPlaceholder={_( 'Grund' )}
                                onChange={e => this.handleChange( 'fieldEquipment', e )}
                                values={this.props.gameReportReferee.fieldEquipment}
                            />

                        </fieldset>

                    </Ons.Card>

                    <Ons.Card>

                        <h3>{_( 'Event-Staff' )}</h3>

                        <fieldset>

                            <Checklist
                                config={this.#gameReportRefereeConfig.eventStaff}
                                disabled={this.props.loading || readonly}
                                id="eventStaff"
                                inputPlaceholder={_( 'Grund' )}
                                onChange={e => this.handleChange( 'eventStaff', e )}
                                values={this.props.gameReportReferee.eventStaff}
                            />

                        </fieldset>

                    </Ons.Card>

                    <Ons.Card>

                        <h3>{_( 'Anmerkungen' )} ({_( 'Offizielle' )})</h3>

                        <fieldset disabled={this.props.loading}>

                            <div className="form-control">

                                <label htmlFor="grr-notes-officials-mercy-rule-period">{_( 'Mercy-Rule ab' )}:</label>

                                <Ons.Input { ...notesOfficialsMercyRulePeriodProps } />

                                <Ons.Input { ...notesOfficialsMercyRuleTimeProps } />

                            </div>

                            <div className="form-control break">

                                <label htmlFor="grr-notes-officials-comment">{_( 'Kommentar' )}:</label>

                                <AutoTextarea
                                    id="grr-notes-officials-comment"
                                    name="notesOfficials.comment"
                                    onChange={this.handleInputChange}
                                    readonly={readonly}
                                    value={this.props.gameReportReferee.notesOfficials.comment}
                                />

                            </div>

                            <div className="form-control break">

                                <label htmlFor="grr-notes-officials-comment2">{_( 'Ausschlussbericht' )}:</label>

                                <AutoTextarea
                                    id="grr-notes-officials-comment2"
                                    name="notesOfficials.comment2"
                                    onChange={this.handleInputChange}
                                    readonly={readonly}
                                    value={this.props.gameReportReferee.notesOfficials.comment2}
                                />

                            </div>

                            {this.renderInput( { title: 'Name', key: 'notesOfficials', key2: 'name' } )}

                        </fieldset>

                    </Ons.Card>

                    {this.props.gameReportRefereeMeta.status !== GRR_DRAFT && this.renderTeamNotes( 'home' )}

                    {this.props.gameReportRefereeMeta.status !== GRR_DRAFT && this.renderTeamNotes( 'away' )}

                    <div className="padded-page-content buttons">

                        {( ( this.props.activeGame.permission === 'referee' && this.props.gameReportRefereeMeta.status === GRR_DRAFT ) || canOverwrite ) &&

                            <>

                                {/* <Ons.Button disabled={this.props.loading || ! this.props.hasLocalChanges} onClick={this.handleSaveDraftClick} modifier="large quiet">{_( 'Entwurf speichern' )}</Ons.Button> */}

                                <Ons.Button disabled={this.props.loading || ! this.props.hasLocalChanges} onClick={this.handleDismissChangesClick} modifier="large quiet">{_( 'Änderungen verwerfen' )}</Ons.Button>

                            </>

                        }

                        {canBeSignedByTeam &&

                            <p className="note">

                                <Ons.Icon icon="fa-info-circle" />

                                {' ' + ( this.teamSignatureExpired() ? _( 'Die Frist zum Unterschreiben ist abgelaufen.' ) : _( 'Du kannst unter den Anmerkungen deines Teams einen Kommentar eingeben und unterschreiben bis:' ) + ' ' + this.getTeamSignatureExpirationDate().toLocaleString() )}

                            </p>

                        }

                        {( canBeSignedByReferee || ( canBeSignedByTeam && ! this.teamSignatureExpired() ) ) && <HoldButton disabled={this.props.loading || ( canBeSignedByReferee && ! this.requiredFieldsFilledIn() )} onClick={this.handleSignClick} label={_( 'Halten zum Unterschreiben' )} />}

                        {canOverwrite && <HoldButton disabled={this.props.loading || ! this.props.hasLocalChanges} onClick={this.handleOverwriteClick} label={_( 'Halten zum Überschreiben' )} />}

                    </div>

                </form>

                {this.props.activeGame.permission === 'referee' && this.props.gameReportRefereeMeta.status === GRR_DRAFT &&

                    <Ons.Fab disabled={this.props.loading || ! this.props.hasLocalChanges} position={this.#actionButtonClass} style={{ bottom: '70px', position: 'fixed' }} ripple={true} onClick={this.handleSaveDraftClick}><Ons.Icon icon='fa-save' /></Ons.Fab>

                }

            </Ons.Page>

        );

    }

}

export default GameReportReferee;